import * as React from 'react';

export class Shape {

    left;
    bottom;

    constructor(left: number, bottom: number) {
        this.left = left;
        this.bottom = bottom;
    }

    static defaultArray: Shape[] = [
        {left: 44, bottom: 90},
        {left: 32, bottom: 86},
        {left: 20, bottom: 36},
        {left: 26, bottom: 16},
        {left: 68, bottom: 82},
        {left: 64, bottom: 8},
        {left: 74, bottom: 60},
        {left: 78, bottom: 46},
        {left: 78, bottom: 30}
    ];
}

export const renderLoginAnimation = (shapes) => [
    <div key={0} id="left-animation">
        <img className="g-anim a1" alt="" src="/images/assets/shape-15.svg"
             style={{left: '32%', top: '24%', width: 12}}/>
        <img className="g-anim a2" alt="" src="/images/assets/shape-14.svg"
             style={{left: '26%', top: '38%', width: 18}}/>
        <img className="g-anim a1" alt="" src="/images/assets/shape-2.svg"
             style={{left: '24%', top: '54%', width: 24}}/>
        <img className="g-anim a2" alt="" src="/images/assets/shape-11.svg"
             style={{left: '28%', top: '70%', width: 32}}/>
        <img className="g-anim a1" alt="" src="/images/assets/shape-15.svg"
             style={{left: '34%', top: '90%', width: 10}}/>
    </div>,
    <div key={1} id="right-animation">
        <img className="g-anim a2" alt="" src="/images/assets/shape-2.svg"
             style={{left: '70%', top: '30%', width: 24}}/>
        <img className="g-anim a1" alt="" src="/images/assets/shape-11.svg"
             style={{left: '74%', top: '50%', width: 18}}/>
        <img className="g-anim a2" alt="" src="/images/assets/shape-7.svg"
             style={{left: '72%', top: '80%', width: 10}}/>
    </div>,
    <div key={2} id="shapes">
        <img id="shape-0" className="shape" alt="" src="/images/assets/shape-17.svg"
             style={{
                 left: shapes[0].left + '%',
                 bottom: shapes[0].bottom + '%',
                 width: 24
             }}/>
        <img id="shape-1" className="shape" alt="" src="/images/assets/shape-16.svg"
             style={{
                 left: shapes[1].left + '%',
                 bottom: shapes[1].bottom + '%',
                 width: 18
             }}/>
        <img id="shape-2" className="shape" alt="" src="/images/assets/shape-12.svg"
             style={{
                 left: shapes[2].left + '%',
                 bottom: shapes[2].bottom + '%',
                 width: 20
             }}/>
        <img id="shape-3" className="shape" alt="" src="/images/assets/shape-3.svg"
             style={{
                 left: shapes[3].left + '%',
                 bottom: shapes[3].bottom + '%',
                 width: 14
             }}/>
        <img id="shape-4" className="shape" alt="" src="/images/assets/shape-1.svg"
             style={{
                 left: shapes[4].left + '%',
                 bottom: shapes[4].bottom + '%',
                 width: 18
             }}/>
        <img id="shape-5" className="shape" alt="" src="/images/assets/shape-1.svg"
             style={{
                 left: shapes[5].left + '%',
                 bottom: shapes[5].bottom + '%',
                 width: 18
             }}/>
        <img id="shape-6" className="shape" alt="" src="/images/assets/shape-3.svg"
             style={{
                 left: shapes[6].left + '%',
                 bottom: shapes[6].bottom + '%',
                 width: 18
             }}/>
        <img id="shape-7" className="shape" alt="" src="/images/assets/shape-5.svg"
             style={{
                 left: shapes[7].left + '%',
                 bottom: shapes[7].bottom + '%',
                 width: 18
             }}/>
        <img id="shape-8" className="shape" alt="" src="/images/assets/shape-1.svg"
             style={{
                 left: shapes[8].left + '%',
                 bottom: shapes[8].bottom + '%',
                 width: 18
             }}/>
    </div>
];

export const parallax = (left, bottom): Shape[] => {
    let calc = (shape: Shape, power: number) => new Shape(
        shape.left + (left - 50) * power,
        shape.bottom + (bottom - 50) * power
    );
    return Shape.defaultArray.map((shape, i) => calc(shape, i % 2 == 0 ? 0.1 : 0.2));
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/animation/LoginAnimation.tsx